<template>
  <div class="myContainer">
    <table-temp :title="title" :flag="1" :tableData="tableData" :columnData="tableConf" @editTable="editTable"
      @handleSelectionChange="handleSelectionChange" :showSummary="true" :summaryMethod="getSummaries">
      <div slot="tool">
        <el-button type="primary" class="borderBtn" @click="addDialog">添加<i class="button-icon icon-tianjia"></i>
        </el-button>
        <el-button type="danger" plain class="borderBtn" @click="delInvestorAndReload">删除<i
            class="button-icon icon-shanchu"></i></el-button>
      </div>
    </table-temp>
    <div class="footerBtn">
      <el-button @click="pre">上一步</el-button>
      <el-button class="mainBtn" @click="DoDebounce(save, 'timer3')">保存</el-button>
      <el-button class="mainBtn" @click="DoDebounce(next, 'timer4')">保存并下一步</el-button>
    </div>
    <investor-dialog :dialogVisible="investorVisible" :title="investorTitle" :detailId="detailId"
      @closeDialog="closeDialog" :codeId="codeId" :totalCapture="totalCapture"
      :currentCapturePercent="currentCapturePercent"></investor-dialog>
  </div>
</template>

<script>
import { step2 } from "@/conf/newAgency";
import { AgencyStep2 } from "@/conf/Agency";
import InvestorDialog from "../dialog/investor";
import TableTemp from "../table";
import comMixin from "common/js/mixin/comMixin";
import { debounce } from 'common/js/tools.js'
import { getInvestor, delInvestor } from "common/js/api";

export default {
  components: {
    InvestorDialog,
    TableTemp,
  },

  // props: ["codeId"],

  mixins: [comMixin],

  data() {
    return {
      title: "出资人（股东）信息",
      tableConf: [],
      // 列表数据
      tableData: [],
      investorVisible: false,
      investorTitle: "",
      investorData: {},
      codeId: this.$route.query.codeId,
      step: 1,
      fundType: "",
      detailId: 0,
      totalCapture: "",
      currentCapturePercent: 0,
    };
  },

  mounted() {
    this.getInvestorData();
    this.tableConf =
      this.$route.path == "/FundManagement/NewAgency" ? step2 : AgencyStep2;
    this.totalCapture =
      this.$route.path == "/FundManagement/NewAgency"
        ? this.Cookies.get("capitalRegisted")
        : this.Cookies.get("capitalAdmitted");
  },

  methods: {
    getSummaries(param) {
      console.log(param);
      const { columns, data } = param;
      const sums = [];
      let captureIndex;
      let capturePercentIndex;
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }

        if (column.property === "capturePercent") {
          capturePercentIndex = index;
        }
        const values = data.map((item) => {
          if (column.property === "capture") {
            captureIndex = index;
            return Number(item[column.property]);
          } else if (column.property === "capturePercent") {
            return Number(item[column.property]);
          }
        });

        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2) + "";
        } else {
          sums[index] = "";
        }
      });
      console.log(sums);
      console.log(`sums[${capturePercentIndex}]:`, sums[capturePercentIndex]);
      console.log("this.totalCapture:", this.totalCapture);
      sums[capturePercentIndex] =
        (
          ((Number(sums[captureIndex]) * 10000) /
            (Number(this.totalCapture) * 10000)) *
          100
        ).toFixed(2) + "%";
      return sums;
    },
    async getInvestorData() {
      const result = await getInvestor(this.codeId);
      let sums = 0;

      result.result.forEach((column, index) => {
        sums = ((sums * 10000 + column.capture * 10000) / 10000).toFixed(2);
      });
      // this.totalCapture = sums;
      console.log("sums", sums);
      // result.result.forEach((column, index) => {
      //   column.capturePercent = ((column.capture / sums) * 100).toFixed(2);
      //   //  column.capturePercent.toFixed(2)
      // });
      this.tableData = result.result;
      this.fundType = this.Cookies.get("fundType");
      this.converInverstorData(this.tableData);
    },

    converInverstorData(data) {
      data.forEach((item) => {
        if (item.qualified == 1) {
          item.qualified = "是";
        }
        if (item.qualified == 0) {
          item.qualified = "否";
        }
      });
    },

    addDialog() {
      this.investorTitle = "添加出资人（股东）";
      this.investorVisible = true;
      this.investorData = {};
      this.$set(this.investorData, "dte", new Date());
    },

    closeDialog() {
      this.investorVisible = false;
      this.reloadData();
    },

    editTable(val) {
      this.investorTitle = "编辑出资人（股东）";
      this.detailId = val.scope.row.id;
      this.investorVisible = true;
      this.currentCapturePercent = val.scope.row.capturePercent;
      // console.log(val.scope.row.capturePercent);
      // console.log(this.tableData);
      // console.log(val.scope);
      // console.log(this.tableData[val.scope.$index])
      // console.log("@@@")
    },

    reloadData() {
      console.log("刷新");
      this.getInvestorData();
    },

    editRow() { },

    save() {
      return true;
    },

    pre() {
      this.$router.replace({
        path: this.$route.path,
        query: {
          flag: this.$route.query.flag,
          codeId: this.codeId,
          step: this.step - 1,
          edit: "update",
        },
      });
      this.$emit("pre");
    },

    DoDebounce(func, timer) {
      debounce(func, 2000, timer, true)
    },
    handleSelectionChange(ids) {
      this.selectIds = ids;
    },
    async delInvestorAndReload() {
      await this.delInvestor();
      this.reloadData();
    },
    async delInvestor() {
      if (!this.selectIds) {
        this.$message({
          message: "请先选择删除的列表,再点击删除!",
          type: "warning",
        });
        return;
      }
      await this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "上一步",
        type: "warning",
      })
        .then(() => {
          delInvestor(this.selectIds);

          this.$message({
            message: "删除成功!",
            type: "success",
          });

          const tempSelectrIds = this.selectIds.split(",");
          this.tableData.forEach((item, index) => {
            if (tempSelectrIds.indexOf(item.id + "") > -1) {
              console.log("delete-->", index);
              delete this.tableData[index];
            }
          });
          console.log("table--after>", this.tableData);
          this.reloadData();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已上一步",
          });
        });
    },
  },
  watch: {
    codeId(newValue) { },
  },
};
</script>

<style scoped lang="scss">
.title {
  margin: 20px;
}

.myContainer {
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;

  &::-webkit-scrollbar {
    // display: none;
  }

  .table ::v-deep  *::-webkit-scrollbar {
    display: none;
  }
}

.footerBtn {
  padding-top: 20px;
}
</style>
